module.exports = __webpack_public_path__ + "img/About-us_website-putih.e6800702.jpg";